// extracted by mini-css-extract-plugin
export default {"pageDivider":"addToQueuePage_pageDivider__HCrhw","queue":"addToQueuePage_queue__1giCd","regContainer":"addToQueuePage_regContainer__Ulbfy"};